import * as ACTION from './actionTypes';
import { callAccedoAPI } from "../../axios/accedoApi";
import {callAPI} from "../../axios/index"

const getSatelliteSignalRequest = () => {
    return {
        type: ACTION.GET_SATELLITE_SIGNAL_REQUEST
    }
}

const getSatelliteSignalSuccess = (apiData) => {
    return {
        type: ACTION.GET_SATELLITE_SIGNAL_SUCCESS,
        payload: apiData,
    }
}

const getSatelliteSignalFailure = (errorMsg) => {
    return {
        type: ACTION.GET_SATELLITE_SIGNAL_FAILURE,
        payload: errorMsg,
    }
}

export const satelliteSignalFetchNowControlTimerFlag = () => {
    return {
        type: ACTION.SATELLITE_SIGNAL_FETCH_NOW_CONTROL_TIMER_FLAG,
        // payload: payload,
    }
}

const satelliteSignalFetchNowControl = (payload)=>{
    return {
        type: ACTION.SATELLITE_SIGNAL_FETCH_NOW_CONTROL,
        payload: payload,
    }
}

export const satelliteSignalFetchNowStatus = (payload) => {
    return {
        type: ACTION.SATELLITE_SIGNAL_FETCH_NOW_STATUS,
        payload: payload,
    }
}

export const satelliteSignalProcessedWebhookTriggered = (payload) => {
    return {
        type: ACTION.SATELLITE_SIGNAL_PROCESSED_WEBHOOK_TRIGGERED,
        payload: payload,
    }
}

export const getSatelliteSignalData = (sid,cdsn) => {
    const apiPath = `/KPI/STB/satelliteSignal/${sid}/${cdsn}`;
    return async function(dispatch) {
        dispatch(getSatelliteSignalRequest());
        callAccedoAPI(`${localStorage.getItem("accedo_url")}${apiPath}`,"GET").then(res => {
            dispatch(getSatelliteSignalSuccess(res));
        })
        .catch(err => {
            dispatch(getSatelliteSignalFailure(err.message));
        });
    };
};

export const postFetchNowSatelliteSignalControl = (sid,cdsn,payload, controlAction) => {
    const controlApiPath = `/control/${cdsn}/${controlAction}`;
    let statusApiPath = `/control/status/${sid}?by=CRID&id=`
    return async function(dispatch) {
        callAccedoAPI(`${localStorage.getItem("accedo_url")}${controlApiPath}`,"POST", payload).then(res => {
            localStorage.setItem(`FetchNowSatelliteSignalSid-${sid}Cdsn-${cdsn}InitiateTime`,new Date().getTime())
            dispatch(satelliteSignalFetchNowControl(res));
            callAPI("/control","POST",{
                controlRequestID: res.body.controlRequestID,
                action: res.body.action,
                sid: sid,
                cdsn: cdsn,
              })
            callAccedoAPI(`${localStorage.getItem("accedo_url")}${statusApiPath}${res.body.controlRequestID}`,"GET").then(response => {
                // console.log(response[0])
                dispatch(satelliteSignalFetchNowStatus(response[0]));
            })
            // setTimeout(()=>{
            //     dispatch(bluetoothDevicesFetchNowControlTimerFlag())
            //   },120000)
        })
        .catch(err => {
            dispatch(getSatelliteSignalFailure(err.message));
        });
    }; 
};